import React, { useEffect, useState } from 'react';
import { LanguagesIcon } from 'lucide-react';
import { getLang, setLang, type Lang } from '../utils/translate';
const options: {
  id: Lang;
  label: string;
  full: string;
}[] = [{
  id: 'en',
  label: 'EN',
  full: 'English'
}, {
  id: 'es',
  label: 'ES',
  full: 'Español'
}];
export function LanguageToggle() {
  const [lang, setLangState] = useState<Lang>('en');
  useEffect(() => {
    setLangState(getLang());
  }, []);
  const choose = (next: Lang) => {
    if (next === lang) return;
    setLangState(next);
    setLang(next);
  };
  return <div className="notranslate flex items-center gap-2 text-sand" translate="no" role="group" aria-label="Language / Idioma" data-id="element-171" data-mp="2f7z6vwkdnxo0">
      <LanguagesIcon size={14} className="text-sand/70" aria-hidden="true" data-id="element-172" data-mp="2afpmsx5y1rtn" />
      <div className="flex rounded-full bg-sand/10 p-0.5" data-id="element-173" data-mp="1mqwq2yhhzfxz">
        {options.map(o => {
        const active = lang === o.id;
        return <button key={o.id} type="button" onClick={() => choose(o.id)} aria-pressed={active} aria-label={o.full} className={`rounded-full px-2.5 py-0.5 text-[11px] font-bold tracking-wide transition-colors duration-150 ${active ? 'bg-sun text-ink' : 'text-sand/80 hover:text-sand'}`} data-id="element-174" data-mp="1hqr1jr6iy9k4">
              {o.label}
            </button>;
      })}
      </div>
    </div>;
}